'use strict';

var appDom = require('../../app-dom');
var detail = require('./detail');
var calendar = require('./calendar');

var init = function(/*actionItem*/) {

	console.log('scheduler-service-detail?');
	console.log(appDom.document.find('.scheduler-detail'));

	if (appDom.document.find('.scheduler-detail').length) {

		console.log('init the scheduler service detail stuff!');

		detail.init();

		calendar.init();

	}

};

module.exports = {
	init: init
};
